import { cn } from "@newxsystems/shared";
import { AbyssCardLink } from "../../../../modules/content/components/AbyssCardLink/AbyssCardLink";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssRichText } from "../../../../modules/content/components/AbyssRichText/AbyssRichText";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;

export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn(
            "grid grid-cols-1 border-l border-t border-iron sm:grid-cols-2",
            columns[columnCount || 3],
          )}
        >
          {items.map((item, index) => (
            <AbyssCardLink
              className={cn(
                "border-b border-r border-t-0 border-iron bg-obsidian/25 p-6 md:p-8",
                item.cardLink &&
                  "before:pointer-events-none before:absolute before:-left-px before:inset-y-0 before:z-10 before:w-px before:bg-primary before:opacity-0 before:transition-opacity before:duration-200 before:content-[''] hover:before:opacity-100",
                spans[Math.min(item.columnSpan || 1, columnCount || 3) as keyof typeof spans],
              )}
              key={index}
              link={item.cardLink}
            >
              <h3 className="abyss-type-subhead mt-8 font-abyss-display font-medium text-foreground md:mt-12">
                {item.heading}
              </h3>
              {item.description ? (
                <AbyssRichText
                  className="mt-4 text-base text-fog md:text-lg"
                  content={item.description}
                />
              ) : null}
            </AbyssCardLink>
          ))}
        </div>
      </div>
    </AbyssSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
